import Faq from "./Faq";
import Greeting from "./Greeting";
import Helper from "../../../shared/modules/Helper";
import MarketingAssets from "../../../shared/components/MarketingAssets";
import PageBanner from "../../../shared/components/PageBanner";
import PropTypes from "prop-types";
import React from "react";
import ShipmentInfo from "./ShipmentInfo";
import StatusBar from "./StatusBar";
import StyleProfile from "./StyleProfile";
import TextMessages from "./TextMessages";
import WhatWereLoving from "./WhatWereLoving";

class LoggedInHomePage extends React.PureComponent {
  static propTypes = {
    "apiToken": PropTypes.string.isRequired,
    "comingOffHoldIsBlocked": PropTypes.bool.isRequired,
    "customerId": PropTypes.string.isRequired,
    "customerOptedInSMS": PropTypes.bool,
    "marketingAssets": PropTypes.array,
    "name": PropTypes.string.isRequired,
    "scenario": PropTypes.string.isRequired,
    "shipmentData": PropTypes.object,
    "styleSurvey": PropTypes.object.isRequired,
    "timeDelivered": PropTypes.string,
    "warehouseClosed": PropTypes.bool.isRequired,
    "warehouseReducedCapacityText": PropTypes.string,
    "wishlistCount": PropTypes.number.isRequired
  };

  static defaultProps = {
    "comingOffHoldIsBlocked": false,
    "customerOptedInSMS": false,
    "marketingAssets": [],
    "shipmentData": null,
    "timeDelivered": null,
    "warehouseReducedCapacityText": ""
  };

  static mapProducts (products) {
    return products.map((productDescriptor) => {
      const {
        "details": {
          "name": description,
          "designer": designerName,
          "insider_price_dollars": memberPrice,
          name,
          "retail_price": retailPrice,
          "thumbnail_urls": [imageUrl],
          "ring_size": ringSize
        },
        id
      } = productDescriptor;

      return {
        description,
        designerName,
        id,
        imageUrl,
        memberPrice,
        name,
        retailPrice,
        ringSize
      };
    });
  }

  constructor (props) {
    super(props);
    const {shipmentData} = this.props;// eslint-disable-line
    if (shipmentData) {
      const {
        "id": shipmentId,
        "products": [...products],
        "time_delivered": timeDelivered,
        "time_sent": timeSent,
        "tracking_number": trackingNumber,
        "tracking_url": trackingUrl,
        "veto_period_expires_at": timeLeft
      } = shipmentData;
      const daysSinceDelivery = Math.round((Date.parse(Date()) - Date.parse(timeDelivered)) / 86400000);
      const productDescriptors = LoggedInHomePage.mapProducts(products);
      const timeDeliverdFormatted = Helper.formatDate(timeDelivered);
      const timeSentFormatted = Helper.formatDateToString(timeSent);


      this.shipment = {
        daysSinceDelivery,
        "id": shipmentId,
        productDescriptors,
        "timeDelivered": timeDeliverdFormatted,
        timeLeft,
        "timeSent": timeSentFormatted,
        trackingNumber,
        trackingUrl
      };
    } else {
      this.shipment = {
        "daysSinceDelivery": null,
        "id": null,
        "timeDelivered": null,
        "timeSent": null,
        "trackingNumber": null,
        "trackingUrl": null
      };
    }
  }

  render () {
    const {apiToken, comingOffHoldIsBlocked, customerId, customerOptedInSMS, marketingAssets, name, styleSurvey, scenario, wishlistCount, warehouseClosed, warehouseReducedCapacityText} = this.props; // eslint-disable-line max-len

    return (
      <div>
        { wishlistCount >= 30 &&
          <StatusBar
            daysSinceDelivery={this.shipment.daysSinceDelivery}
            scenario={scenario}
            timeDelivered={this.shipment.timeDelivered}
            trackingUrl={this.shipment.trackingUrl}
            warehouseClosed={warehouseClosed}
          />
        }
        {this.shipment.productDescriptors?.length === 4 &&
          <PageBanner
            classes="page-banner-fourth-piece"
            desc="For a limited time, get a 4th piece with your set!"
            title="Rewards Perk!"
          />
        }
        <Greeting
          comingOffHoldIsBlocked={comingOffHoldIsBlocked}
          customerName={name}
          scenario={scenario}
        />
        { this.shipment.id &&
          <ShipmentInfo
            apiKey={apiToken}
            customerId={customerId}
            scenario={scenario}
            shipment={this.shipment}
            warehouseReducedCapacityText={warehouseReducedCapacityText}
          />
        }
        <hr className="long-light-grey-line" />
        <WhatWereLoving
          wishlistCount={wishlistCount}
        />
        <MarketingAssets marketingAssets={marketingAssets} />
        <StyleProfile styleSurvey={styleSurvey} />

        <hr className="long-light-grey-line" />
        {!customerOptedInSMS &&
          <TextMessages />
        }
        <hr className="long-light-grey-line" />
        <Faq />
      </div>
    );
  }
}

export default LoggedInHomePage;
